import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { isGridView } = {}) => ({
  button: {
    '& #count-button': {
      width: 130,
      '& svg': {
        fontSize: 20,
      },
    },
    [theme.breakpoints.down('md')]: {
      marginTop: 'auto',
      '& #count-button': {
        height: 24,
        width: isGridView ? 120 : 95,
      },
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        marginTop: 'auto',
        '& #count-button': {
          height: 24,
          width: isGridView ? 120 : 95,
        },
      }),
    },
  },
}));
